import { render, staticRenderFns } from "./CollectDataPopup.vue?vue&type=template&id=23b68ede&scoped=true&"
import script from "./CollectDataPopup.vue?vue&type=script&lang=js&"
export * from "./CollectDataPopup.vue?vue&type=script&lang=js&"
import style0 from "./CollectDataPopup.vue?vue&type=style&index=0&id=23b68ede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b68ede",
  null
  
)

export default component.exports